import React, { useState, useEffect } from 'react';
import { CHATFLOWID, APIHOST, BOT_WELCOME_MSG, BOT_ERROR_MSG, BOT_FOOTER_TEXT, BOT_INPUTTEXT_PLACEHOLDER } from '../../helpers/constants';
import { decrypt } from '../../helpers/encrypt';
import { insertActivityLog, chatSessionStart } from '../../actions';
import { getUserType, getAppSource } from '../../helpers';
import Cookies from 'js-cookie';

export const ChatBotAiFlowise =  React.memo(() => {
  const [chatbotHeight, setChatbotHeight] = useState(); 
  const [btnBgColor, setBtnBgColor] = useState(Cookies.get('chatBotNo') == '1' ? '#3B81F6' : '#3B81F6'); 
  const [titleBgColor, setTitleBgColor] = useState(Cookies.get('chatBotNo') == '1' ? '#3B81F6' : '#3B81F6'); 
  const [chatIcon, setChatIcon] = useState(Cookies.get('chatBotNo') == '1' ? 'https://mlw-uat.bsifinancial.com/images/icon/chatIcon1_v1.png' : 'https://myloanweb.com/images/icon/chatIcon2_v2.png'); 
  const [chatAvatar, setChatAvatar] = useState(Cookies.get('chatBotNo') == '1' ? 'https://mlw-uat.bsifinancial.com/images/icon/chatavtar1_v1.png' : 'https://myloanweb.com/images/icon/chatavtar2_v1.png'); 
  const [chatBotTitle, setChatBotTitle] = useState(Cookies.get('chatBotNo') == '1' ?  'Chat With Milo' : 'Chat With Milo')
  const [chatBotHeading, setChatBotHeading] = useState(Cookies.get('chatBotNo') == '1' ?  'Milo - Virtual Assistant' : 'Milo')
  const [defaultOpen, setDefaultOpenStatus] = useState(Cookies.get('chatBotDefaultOpen') == 'true' ? false : false); 

  const updateHeight = () => {
    const newHeight = window.innerHeight * 0.7; 
    setChatbotHeight(newHeight);
  };
 
  useEffect(() => {
    updateHeight();

    window.addEventListener('resize', updateHeight);
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  const sendActivityLog = async (message, status) => {
    const data = {
      "accountNumber": Cookies.get('loanNumber'),
      "activityCode": "UAL213",
      "activityStatus": status,
      "action": "",
      "controller": "AIChatBot",
      "apiName": "AIChatBot",
      "activityRemark":  message,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": "",
    };

    await insertActivityLog(data);
  }
 
  // async function createChatSession(sessionId) {
	// 	const loannumber = decrypt(Cookies.get('loanNumber'));
  //   const url = `${APIHOST}/api/v1/prediction/${CHATFLOWID}`;

  //   const payload = {
  //     question: "this is a test question.",
  //     overrideConfig: {
  //       vars: {
  //         loannumber: loannumber,
  //         session_id: sessionId
  //       },
  //       sessionId: sessionId,
  //     }
  //   };

  //   const retries = 2
  //   const delay = 1000
    
  //   for (let i = 0; i < retries; i++) {
  //     try {
  //       const response = await fetch(url, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(payload)
  //       });

  //       if (!response.ok) throw new Error(`HTTP error ${response.status}`);


  //       const data = await response.json();

  //       return data.sessionId ||
  //         (data.usedTools?.[0]?.toolOutput &&
  //          JSON.parse(data.usedTools[0].toolOutput).session_id) ||
  //         null;
  //     } catch (error) {
  //       if (i < retries - 1) {
  //         await new Promise(resolve => setTimeout(resolve, delay));
  //         continue;
  //       }
  //       return null;
  //     }
  //   }
  // }

  const getSessionId = async () => {
      const res = await chatSessionStart(Cookies.get('loanNumber'));
      if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
        if (res?.responseData?.responseData.aiChatbotSessionId) {
          // createChatSession(res?.responseData?.responseData.aiChatbotSessionId)
          Cookies.set('sessionId', res?.responseData?.responseData.aiChatbotSessionId);
          return res?.responseData?.responseData.aiChatbotSessionId;
        } else {
          return false
        }
      }
  }

  const chatBot = (data) => {

    const script = document.createElement('script');
    script.type = 'module';
    script.innerHTML = `
      import Chatbot from 'https://cdn.jsdelivr.net/npm/flowise-embed/dist/web.js';
      Chatbot.init({
        chatflowid: '${CHATFLOWID}',
        apiHost: '${APIHOST}',
        chatflowConfig: {
         "sessionId": '${data}',
         "vars": {
						"loannumber": "${decrypt(Cookies.get('loanNumber'))}",
            "session_id": '${data}'
					},
        },
        observersConfig: {
          observeUserInput: (userInput) => {
            
          },
          observeMessages: (messages) => {
            
          },
          observeLoading: (loading) => {
           
          },
        },
        theme: {
         button: {
          backgroundColor: '${btnBgColor}',
          right: 20,
          bottom: 20,
          size: 88, 
          dragAndDrop: true,
          iconColor: 'white',
          customIconSrc: '${chatIcon}',
          autoWindowOpen: {
            autoOpen: false, //parameter to control automatic window opening
            openDelay: 10, // Optional parameter for delay time in seconds
            autoOpenOnMobile: false, //parameter to control automatic window opening in mobile
          },
        },
        tooltip: {
          showTooltip: true,
          tooltipMessage: "${chatBotTitle}",
          tooltipBackgroundColor: 'black',
          tooltipTextColor: 'white',
          tooltipFontSize: 20,
        },
        chatWindow: {
          showTitle: true,
          showAgentMessages: true,
          title: '${chatBotHeading}',
          titleAvatarSrc: '${chatIcon}',
          titleBackgroundColor: '${titleBgColor}',
          titleTextColor: '#ffffff',
          welcomeMessage: '${BOT_WELCOME_MSG}',
          errorMessage: '${BOT_ERROR_MSG}',
          backgroundColor: '#ffffff',
          backgroundImage: 'enter image path or link', // If set, this will overlap the background color of the chat window.
          height: 450,
          width: 560,
          fontSize: 16,
          starterPrompts: ['What is next payment due date?', 'Need Mortgage statement?', 'Save on Home Insurance'], // It overrides the starter prompts set by the chat flow passed
          starterPromptFontSize: 15,
          clearChatOnReload: false, // If set to true, the chat will be cleared when the page reloads
          sourceDocsTitle: 'Sources:',
          renderHTML: false,
          botMessage: {
            backgroundColor: '#f7f8ff',
            textColor: '#303235',
            showAvatar: true,
            avatarSrc: '${chatAvatar}',
          },
          userMessage: {
            backgroundColor: '#3B81F6',
            textColor: '#ffffff',
            showAvatar: true,
            avatarSrc: "https://mlw-uat.bsifinancial.com/images/icon/userIcon.svg",
          },
          textInput: {
            placeholder: '${BOT_INPUTTEXT_PLACEHOLDER}',
            backgroundColor: '#ffffff',
            textColor: '#303235',
            sendButtonColor: '#3B81F6',
            maxChars: 1000,
            maxCharsWarningMessage: 'You exceeded the characters limit. Please input less than 1000 characters.',
            autoFocus: true, // If not used, autofocus is disabled on mobile and enabled on desktop. true enables it on both, false disables it on both.
            sendMessageSound: true,
            // sendSoundLocation: "send_message.mp3", // If this is not used, the default sound effect will be played if sendSoundMessage is true.
            receiveMessageSound: true,
            // receiveSoundLocation: "receive_message.mp3", // If this is not used, the default sound effect will be played if receiveSoundMessage is true.
          },
          feedback: {
            color: '#303235',
          },
          dateTimeToggle: {
            date: true,
            time: true,
          },
          footer: {
            textColor: '#303235',
            text: '${BOT_FOOTER_TEXT}',
            company: 'Bizzy Labs',
            companyLink: 'https://bizzylabs.tech/',
          }
           
        },
      },
    }); 
    `;
      
      document.body.appendChild(script);
      sendActivityLog("Flowise AIChatbot UI successfully loaded for borrower on MLW.", "Success")
      Cookies.set('chatBotDefaultOpen', false)
      // Cleanup the script tag
      return () => {
        document.body.removeChild(script);
      };
  }

  useEffect(() => {

   if (decrypt(Cookies.get('loanNumber'))) { 
    if (Cookies.get('sessionId')) {
       chatBot(Cookies.get('sessionId'))
      //  createChatSession(Cookies.get('sessionId'))
    } else {
      const mlwChatSessionId = getSessionId();
      mlwChatSessionId.then((data) =>   {    
      if (data) {
        chatBot(data)
        }
      })
    }
  }

  }, []);

  return (
   <></>
  );
});
 